import { useEffect, useState } from "react";
import { BasicPage } from "../../../../theme/Component/BasicPage";
import { ListMenu } from "../../../../theme/Component/ListMenu";
import useDataBean from "../../../../../core/services/dataBean/useDataBean";
import { _QualityInspectionChangeParts, _single } from "../../../../../core/services/dataBean/EntityCatalog";
import { BasicTable, MASK_BOOLEAN, MASK_BOOLEAN_ICON } from "../../../../theme/Component/BasicTable";
import { toast } from "react-toastify";
import useModal, { MODAL_LG, MODAL_md, MODAL_SM, MODAL_XL } from "../../../../theme/Component/hooks/useModal";
import { ModalConfirm } from "../../../../theme/Component/ModalConfirm";
import { Modal } from "../../../../theme/Component/Modal";
import { SelectTHConstantsValue } from "../../../../bpm/config/Componentes/SelectTHConstantsValue";
import { BasicButton } from "../../../../theme/Component/BasicButton";
import { FileService } from "../../../../../core/services/FileService";
import { QualityInspectionChangePartsItems } from "./QualityInspectionChangePartsItems/QualityInspectionChangePartsItems";
import usePaginator from "../../../../theme/Component/usePaginator";
import { InputDate } from "../../../../theme/Input/InputDate";

interface ComponentData {
    isModal?: boolean;
    _ProductionOrder?: any;
}

export const QualityInspectionChangeParts = ({ _ProductionOrder, isModal }: ComponentData) => {

    const { instance, bean, setBean, lista, setLista } = useDataBean(_QualityInspectionChangeParts);
    const fileservice = new FileService();
    const paginator = usePaginator();

    const [state, setState] = useState<number>(1);

    const modal = useModal("", MODAL_LG)
    const modalChange = useModal("", MODAL_SM);
    const modalItems = useModal("Piezas a Cambiar", MODAL_LG);

    useEffect(() => {
        getLista();
    }, [_ProductionOrder, paginator.page])

    const getLista = () => {
        let props: any = {
            IDProductionOrder: _ProductionOrder?.IDProductionOrder
        }

        if (state) props.State = state;

        instance.getQualityInspectionChangePartsRender(paginator.page, 15, props).then(
            (resp) => {
                paginator.setPages(resp.NumberOfPages);
                paginator.setRecords(resp.NumberOfPages * 15);
                setLista(resp.List)
            }).catch(
                err => { toast.error(err) }
            )
    }

    const create = () => {
        setBean({
            State: 1,
            IDProductionOrder: _ProductionOrder?.IDProductionOrder,
            IDProductVariant: _ProductionOrder?.IDProductVariant,
            IDEmployee: _single.getAccountID(),
        });
        modal.open("Agregar Cambio de Piezas")
    }

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: _single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]

    const head = [
        { title: 'ID', property: 'IDQualityInspectionChangeParts', visible: true },
        { title: 'Turno', property: 'WorkShiftName', visible: true },
        { title: 'Cambio', property: 'ChangeTypeName', visible: true },
        { title: 'Total de Piezas Cambiadas', property: 'TotalQuantity', visible: true },
        { title: 'Fecha', property: 'Since', visible: true },
    ]

    const [confirmAction, setConfirmAction] = useState<() => void>(() => () => { });

    const openConfirm = (text: string, fn: () => void) => {
        setConfirmAction(() => fn);
        modalChange.open(text)
    };

    const changeStateItem = (newState: number) => {
        let x = { ...bean, State: newState };


        editaItem(x);
    };

    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: _single.canEdit(), evento: () => { modal.open("Editar Cambio de Piezas") } },
            { titulo: 'Piezas a Cambiar', icono: 'ri-list-check', visible: _single.canEdit(), evento: () => { modalItems.open() } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: _single.canDelete() && bean.State == 1, evento: () => { openConfirm("Confirmar Eliminación", () => changeStateItem(3)) } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    const editaItem = (obj: any) => {
        instance.updateQualityInspectionChangeParts(obj).then(
            (resp: any) => {
                getLista();
                modal.close();
                modalChange.close();
            }
        ).catch(err => {
            toast.error(err);
        })
    }

    const [missingFields, setMissingFields] = useState<string[]>([]);

    const validateData = () => {
        if (validateForm() > 0) {
            toast.error("Faltan campos obligatorios por completar");
            return;
        } else {
            editaItem(bean);
        }
    }

    const validateForm = () => {
        const requiredFields = [
            "IDWorkShift", "IDChangeType"
        ];
        let missing = [];
        for (let field of requiredFields) {
            if (bean[field] === null || bean[field] === undefined || bean[field] === "") {
                missing.push(field);
            }
        }
        setMissingFields(missing);
        return missing.length;
    };

    const baseComponent = () => {
        return (
            <div className="row">
                <div className="col-md-4">
                    <label>Estado</label>
                    <select value={state} onChange={(e) => {
                        const value = e.target.value ? Number(e.target.value) : null
                        setState(value)
                    }} className="form-select">
                        <option value="">...</option>
                        <option value="1">Creado</option>
                        <option value="3">Eliminado</option>
                    </select>
                </div>
                <div className="col-md-4">
                    <BasicButton useMargin eventClick={() => { getLista() }} icon="ri-search-line" children={`Buscar`} />
                </div>
                <div className="col-md-12">
                    <BasicTable
                        body={lista}
                        head={head}
                        rowSet={setBean}
                        listButtons={listaBotones()}
                        iconButtons={iconButtonsItem}
                        pageTop={paginator.page}
                        next={paginator.next}
                        back={paginator.back}
                        records={paginator}
                    />
                </div>

                <div className="col-md-12">
                    <Modal modal={modal.modal} updateModal={modal.setModal} eventModal={() => { validateData() }}>
                        <div className="row">
                            {bean.IDQualityInspectionChangeParts &&
                                <div className="col-md-6">
                                    <InputDate label="Fecha" name="" value={bean.Since} setDate={(e) => { setBean({ ...bean, Since: e }) }} />
                                </div>
                            }
                            <div className="col-md-6">
                                <label className={`${missingFields.includes('IDWorkShift') ? 'has-error' : ''}`} >Turno de Trabajo</label>
                                <SelectTHConstantsValue label=" " code={904} onChange={(e) => { setBean({ ...bean, IDWorkShift: e }) }} value={bean.IDWorkShift} />
                            </div>
                            <div className="col-md-6">
                                <label className={`${missingFields.includes('IDChangeType') ? 'has-error' : ''}`} >Cambio</label>
                                <SelectTHConstantsValue label=" " code={911} onChange={(e) => { setBean({ ...bean, IDChangeType: e }) }} value={bean.IDChangeType} />
                            </div>
                        </div>
                    </Modal>

                    <Modal modal={modalItems.modal} updateModal={modalItems.setModal}>
                        <QualityInspectionChangePartsItems QualityInspectionChangeParts={bean} />
                    </Modal>

                    <ModalConfirm modal={modalChange.modal} updateModal={modalChange.setModal} eventModal={() => { confirmAction() }}>
                        <strong>¿Desea Continuar con la accion?</strong>
                    </ModalConfirm>
                </div>
            </div>
        )
    }

    return (
        <>
            {isModal ?
                <>
                    {baseComponent()}
                </>
                :
                <BasicPage titulo="Calidad - Cambio de Piezas">
                    {baseComponent()}
                </BasicPage>
            }
        </>
    )
}